var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "display-flex flex-items-start flex-content-between",
        { "with-border-bottom": !_vm.isLast },
      ],
      style: _vm.componentStyle,
    },
    [
      _vm.isRequired
        ? _c(
            "div",
            {
              staticClass: "display-flex flex-items-start",
              staticStyle: { gap: "var(--spacing-3xs)" },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "padding-x-6xs margin-top-5xs",
                attrs: { icon: _vm.$v6.solid.faLock, "fixed-width": "" },
              }),
              _vm._v(" "),
              _c("div", [
                _c("strong", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _vm.isShowingDescription
                  ? _c(
                      "p",
                      { staticClass: "margin-top-4xs margin-bottom-sm" },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.description) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "display-flex flex-items-start",
              staticStyle: { gap: "var(--spacing-xs)" },
            },
            [
              _c("input", {
                staticClass: "with-icon",
                attrs: {
                  id: `cookies-${_vm.titleKebabCased}`,
                  type: "checkbox",
                },
                domProps: { checked: _vm.isChecked },
                on: { change: _vm.checkboxChanged },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "margin-0",
                  style: _vm.labelStyle,
                  attrs: { for: `cookies-${_vm.titleKebabCased}` },
                },
                [
                  _c(
                    "span",
                    { staticClass: "position-relative" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "unchecked-icon",
                        staticStyle: {
                          color: "var(--icon-color)",
                          cursor: "var(--input-cursor)",
                        },
                        attrs: {
                          icon: _vm.$v6.regular.faSquare,
                          "fixed-width": "",
                          size: "lg",
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "hover-icon",
                        staticStyle: {
                          color: "var(--icon-color)",
                          cursor: "var(--input-cursor)",
                        },
                        attrs: {
                          icon: _vm.$v6.regular.faSquare,
                          "fixed-width": "",
                          size: "lg",
                        },
                      }),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "checked-icon",
                        attrs: {
                          icon: _vm.$v6.solid.faSquareCheck,
                          "fixed-width": "",
                          size: "lg",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("strong", [_vm._v(_vm._s(_vm.title))]),
                    _vm._v(" "),
                    _vm.isShowingDescription
                      ? _c(
                          "p",
                          { staticClass: "margin-top-4xs margin-bottom-sm" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.description) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "link flat secondary compact margin-0 padding-y-0",
          staticStyle: {
            "--link-color": "var(--fa-dk-blue)",
            "--link-hover-color": "var(--fa-blue)",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("showCookieDescription", _vm.title)
            },
          },
        },
        [
          _c("font-awesome-icon", {
            attrs: { icon: _vm.$v6.solid.faCircleInfo },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }